import { useAppSelector } from '../../global/hooks';
import {
	selectBpm,
	selectMode,
	selectTimeSignature,
	setActiveChordId,
	setActiveSectionId,
	setActiveSectionRepeatIndex,
	setMode
} from '../../store/appSlice';
import { selectEnabledSections } from '../../store/sectionsSlice';
import { Id } from '../../types';
import { playChords } from '../../utils/playChords';
import PauseIcon from '../Icons/PauseIcon';
import PlayIcon from '../Icons/PlayIcon';
import BpmEdit from './BpmEdit';
import TimeSignatureEdit from './TimeSignatureEdit';
import { OtherButtons, PlayButton, StyledPlayBar } from './styles';
import { useDispatch } from 'react-redux';
import * as Tone from 'tone';

// create synth once
const synth = window != null ? new Tone.PolySynth(Tone.Synth).toDestination() : null;

export default function PlayBar() {
	const dispatch = useDispatch();
	const isPlaying = useAppSelector(selectMode) === 'play';
	const sections = useAppSelector(selectEnabledSections);
	const isDisabled = sections.length === 0 && !isPlaying;
	const bpm = useAppSelector(selectBpm);
	const timeSignature = useAppSelector(selectTimeSignature);

	const setCurrentSection = (sectionId: Id | null) => dispatch(setActiveSectionId(sectionId));
	const setCurrentChord = (chordId: Id | null) => dispatch(setActiveChordId(chordId));
	const setCurrentSectionRepeatIndex = (repeatIndex: number) =>
		dispatch(setActiveSectionRepeatIndex(repeatIndex));

	const handlePlay = () => {
		if (window == null) return;
		dispatch(setMode(isPlaying ? 'edit' : 'play'));
		Tone.Transport.bpm.value = bpm;
		Tone.Transport.timeSignature = timeSignature;

		if (isPlaying && synth) {
			// STOP
			synth.volume.value = -99;
			Tone.Transport.cancel();
			Tone.Transport.stop();
			synth.releaseAll();
			setCurrentChord(null);
		} else if (synth) {
			synth.volume.value = 0;
			synth.releaseAll();
			// PLAY
			playChords(
				synth,
				sections,
				setCurrentSection,
				setCurrentChord,
				setCurrentSectionRepeatIndex,
				timeSignature
			);
			Tone.Transport.start();
		}
	};
	return (
		<StyledPlayBar className="play-bar">
			<PlayButton onClick={handlePlay} disabled={isDisabled}>
				{isPlaying ? <PauseIcon /> : <PlayIcon width={32} height={32} />}
			</PlayButton>
			<OtherButtons>
				<BpmEdit />
				<TimeSignatureEdit />
			</OtherButtons>
		</StyledPlayBar>
	);
}
